module.exports = __webpack_public_path__ + "static/img/img_weapp_qr.2bd9c4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_weapp_qr.png
// module id = BvC2
// module chunks = 1